export default {
  selectTheDirectoryTreeNodeFirst: '请先选择目录树节点',
  theBatchDeletionIsSuccessful: '批量删除成功',
  pleaseSelectTheDataYouWantToDelete: '请选择要删除的数据',
  whetherToDeleteTheSelectedData: '是否删除选中的数据?',
  theNodeWasEditedSuccessfully: '编辑节点成功',
  failedToAddNewNode: '新增节点失败',
  theNewNodeIsAdded: '新增节点成功',
  dynamicModelCoding: '动态模型编码',
  founder: '创始人',

  disassociate: '取消关联关系',
  associateModel: '关联模型',
  setEffect: '设置动效',
  setRule: '设置规则',
  PleaseSelectAListOfDevices: '请选择设备列表',
  measurementPointAssociation: '测点关联',
  pointCode: '测点编码',
  pointName: '测点名称',
  rulesSetting: '规则设置',
  theNodeDeletionSucceeded: '删除节点成功',
  whetherToConfirmTheDeletionOfTheCurrentNode: '是否确认删除当前节点?',
  pleaseDeleteAllDevicesBeforeYouCanDeleteThem:
    '此目录下关联着多个设备，请先删除全部设备后才能删除！',
  thereAreMultipleSubdirectoriesAssociatedWithThisDirectory:
    '此目录下关联着多个子目录，请先删除全部子目录后才能删除！',
  youCannotSelectYourselfAsTheParentNode: '不能选择自身作为父节点',
  thisActionIsIrreversible: '此操作不可逆',
  auxiliaryMachines: '辅助机器',
  motor: '发动机',

  panelNameNumber: '面板名称/编号',
  dynamicModelname: '动态模型名称',
  uncheckTheAssociation: '取消选中关联关系',
  dynamicModelCategories: '动态模型类别',
  container: '容器',
  deleteTheDevice: '删除设备',
  theMeasurementPointOperationFailed: '测点操作失败',
  theMeasurementPointOperationWasSuccessful: '测点操作成功',
  setStartStopRules: '火焰高度',
  containerLevel: '容器液位',
  pleaseEnterADeviceName: '请输入设备名称',
  pleaseEnterTheDeviceCode: '请输入设备位号',
  editTheTableOfContents: '编辑目录',
  addANewDirectory: '新增目录',
  pleaseEnterAPositiveInteger: '请输入正整数',
  sort: '排序',
  numbersAreCreatedAutomaticallyByTheBackground: '编号由后台自动创建',
  dynamicModelNumbering: '动态模型编号',
  pleaseSelectDynamicModel: '请选择动态模型',
  theSceneModelIsAutomaticallyEchoed: '场景模型自动回显',
  sceneModel: '场景模型',
  pleaseSelectADeviceCategory: '请选择设备类别',
  pleaseEnterTheDeviceNumber: '请输入设备位号',
  dynamicModelAssociation: '动态模型关联',
  selectColumnFirst: '请先选择测点列',
  dissolveTheRelationshipSuccessfully: '解除关系成功',
  confirmUnlink: '是否确认取消当前选中测点动效关联?',
  dynamicModelListFetchFailed: '动态模型列表获取失败',
  ruleCategoryAcquisitionFailed: '规则类别获取失败',
  measurementPointsHaveBeenAdded: '测点已经添加',
  theCurrentDeviceDoesNotHaveASceneModelAssociatedWithIt: '当前设备未关联场景模型',
  deviceCategoryAcquisitionFailed: '设备类别获取失败',
  pleaseSelectTheDeviceName: '请选择设备名称',
  pleaseFillInTheDirectoryName: '请填写目录名称',
  enterAkeywordSearchQueryHere: '此处输入关键词搜索查询',
  ifLeftBlankItIsTheRootDirectory: '置空则为根目录',
  directoryName: '目录名称',
  flameHeight: '火焰高度',
  propertyRenderingFailed: '属性渲染失败',
  modelEditing: '模型编辑',

  selectEditNode: '请选择编辑节点',

  doYouWantToSaveModelNodeInformation: '是否保存模型节点信息？',
  modelTools: '模型工具',
  theNumberOfImpressionsIsRequired: '展示数量为必填项',
  panelCodingIsRequired: '面板编码为必填项',
  thePanelNameIsRequired: '面板名称为必填项',
  numberOfImpressions: '展示数量',
  startTheThresholdAalarmSwitch: '启动阈值报警开关',

  theMaximumNumberOfMeasurementPointsIs8: '测点数量最多保存为8个',
  aListOfDynamicModels: '动态模型列表',
  theCurrentModelDoesNotExist: '当前模型不存在',
  enableTheRuleSwitch: '启用规则开关',
  colorPriorityIsDisplayedInTheOrderInWhichTheRulesAreSet: '颜色优先级展示按照设置规则的先后顺序',
  setUpRules: '设置规则',
  synchronizeData: '同步数据',
  // eslint-disable-next-line no-dupe-keys
  propertyRenderingFailed: '属性渲染失败',
  confirmReset: '是否确认重置？',
  itIsForbiddenToSetTheSameRuleForTheSameSeasurementPoint: '同一测点禁止设置相同规则',
  deletethisBank: '删除本行',
  addALineBelow: '在下方增加一行',
  pleaseSelectAMeasurementPoint: '请选择测点',
  activateTheTool: '激活工具',
  Autofill: '自动填充',
  pleaseFillInTheItem: '请填写所属项目',
  belongsToTheProject: '所属项目',

  theMeasurementPointRequestFailed: '测点请求失败',
  theCurrentDeviceDoesNotHaveAMeasurementPointAssociatedWithIt: '当前设备未关联测点',
  deletesTheCurrentlySelectedPanel: '删除当前选中面板',
  createAMeasurementPointDisplayPanel: '创建测点展示面板',
  measurementPointCodeOrMeasurementPointName: '测点编码或测点名称',
  demonstrateAssociatedMeasurementPoints: '展示关联测点',
  numberOfMeasurementPoints: '测点数量',
  pleaseFillInTheParentNode: '请填写上级节点',
  parentNode: '上级节点',
  pleaseFillInTheDeviceName: '请填写设备名称',
  theMaximumNumberOfPanelsHasBeenReached: '面板数量已达上限',
  panelDeletionFailed: '面板删除失败',
  thePanelWasDeletedSuccessfully: '面板删除成功',
  measurementPointDrive: '测点驱动',
  measurementPointType: '测点类型',
  addAssociatedMeasurementPoints: '添加关联测点',
  pleaseFillInTheDeviceNumber: '请填写设备位号',
  collapseAll: '收起全部',
  expandAll: '展开全部',
  directoryTree: '目录树',

  failedToAddPanel: '添加面板失败',
  panelContent: '面板展示的测点内容',
  panelSwitch: '面板开关',
  panelManagement: '面板管理',
  panelNumber: '面板编号',
  panelName: '面板名称',
}
